<template>
  <section
    class="services base-section sm"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container col">
      <strong class="label primary-color-text text-base-1 text-primary">{{ convertToHtml($t('widgets.services.title')) }}</strong>
      <h2
        class="font-semibold text-[20px] mb-4"
      >
        {{ convertToHtml($t('widgets.services.descr')) }}
      </h2>

      <div class="row services__items">
        <div
          v-for="i in 4"
          :key="i"
          class="services__item row col s12 m6 valign-wrapper"
        >
          <div class="block-img col s3">
            <svg
              class="svg-icon"
              viewBox="0 0 200 200"
              :alt="$t(`widgets.services.item${i}.title`)"
            >
              <use
                class="svg-use"
                :xlink:href="$t(`widgets.services.item${i}.icon`) + '#icon'"
              ></use>
            </svg>
          </div>
          <div class="block-text col s9">
            <div
              class="text-[16px] font-semibold text-primary-800"
              v-html="$t(`widgets.services.item${i}.title`)"
            ></div>
            <p v-html="$t(`widgets.services.item${i}.descr`)"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.services {
  margin: 0 0 2rem;
  font-size: 1rem;
  @media only screen and (min-width: 601px) {
    font-size: 11px;
  }
  &__item {
    max-width: none;
    margin: 1rem 0;
    @media only screen and (min-width: 601px) {
      padding-right: 5px;
      margin: 2rem 0;
    }
  }
}
</style>
